import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UtilService } from '@helpers/util.service';

@Component({
  selector: 'app-main-frame',
  templateUrl: './main-frame.component.html',
  styleUrls: ['./main-frame.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainFrameComponent implements OnInit {
  @Input() photos: string[] = [];
  @Input() showOnlyPhoto: boolean;
  @Input() housingPlans: string[] = [];
  @Input() videos: string[] = [];
  @Input() realPropertyId: number = null;
  @Input() playVideo: boolean = null;
  @Input() applicationId: number = null;
  @Input() removeBorder = false;
  @Input() canOpenPhoto: boolean = null;
  @Input() public likesCount: number = null;
  @Input() public readonly commentsCount: number = null;

  @Input()
  public reserved: boolean;

  @Input()
  public readonly prefix: string = null;

  @Input()
  public readonly toolBarForm: 'short' | 'normal' = 'normal';

  @Input() public inFavourites: boolean = null;

  @Input() public readonly showToolbar: boolean = true;

  @Input()
  public readonly toolbarMode: 'vr' | 'hr' = 'vr';

  @Input()
  public readonly containerWidth: string = '400px';

  @Input()
  public readonly containerHeight: string = '718px';

  @Input()
  public galleryVisibleImageCount = 3;

  @Input()
  public readonly galleryItemWidth: string = '127px';

  @Input()
  public readonly galleryItemHeight: string = '78px';

  /**
   *
   * Является переходом на детализацию объекта в новой вкладке
   *
   */
  @Input()
  public readonly isLink: boolean = true;

  displayGalleria = false;
  activeIndex = 0;

  public containerStyles: { 'flex-direction': string; width: string; height: string };

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];

  @Output() openGalleria = new EventEmitter<boolean>();

  constructor(public util: UtilService) {}

  ngOnInit(): void {
    if (this.housingPlans && this.housingPlans?.length !== 0) {
      if (this.photos && this.photos?.length !== 0) {
        this.photos = this.photos.concat(this.housingPlans);
      }
    }

    this.containerStyles = {
      'flex-direction': this.toolbarMode === 'vr' ? 'row' : 'column',
      width: this.containerWidth,
      height: this.containerHeight,
    };
  }

  onOpenGalleria(event: boolean) {
    this.openGalleria.emit(event);
  }

  onOpenPhoto(item: any) {
    if (item && this.videos.length === 0) {
      this.activeIndex = this.photos.findIndex((el) => el === item);
      this.displayGalleria = true;
    }
  }

  closeGalleria() {
    this.displayGalleria = false;
    this.activeIndex = 0;
    this.openGalleria.emit(false);
  }

  public onImageError(event: Event): void {
    (event.target as HTMLImageElement).src = 'assets/images/no_image.jpeg';
  }
}
